/* eslint-disable */
import gql from "graphql-tag";
export const GET_HOLLOW_FIBER_PARTS_LISTING = gql`query getHollowFiberPartsListing($published: Boolean!) {
  getHollowFiberPartsListing(published: $published) {
    edges {
      node {
        id
        Effective_Length
        Fiber_Count
        Fiber_ID_MM
        Inlet_Retentate
        Is_Active
        MWCO
        Membrane_Chemistry
        Module_Family
        More_Info_Link
        Part_Condition
        Part_Number
        Part_Number_Link
        Permeate
        Qty
        SA_CM2
        SA_CM2_Range
        SA_M2
      }
    }
  }
}`;


export const GET_PART_NUMBERS = gql`query getHollowFiberPartsListing($published: Boolean!) {
  getHollowFiberPartsListing(published: $published) {
    edges {
      node {
        id
        Part_Number
      }
    }
  }
}`;
